import { compose } from 'redux'
import { connect } from 'react-redux'
import { withServices } from 'src/services/ServiceContext'
import PrestitialAd from 'src/components/PrestitialAd'
import { actions as adActions } from 'src/features/ads/AdsSlice'

const mapDispatchToProps = dispatch => ({
  resetPrestitialAd: () => dispatch(adActions.prestitialAdReset())
})

const mapStateToProps = state => ({
  prestitialAd: state?.adsReducer?.prestitialAd
})

export default compose(
  withServices(resolve => ({
    Session: resolve('Session')
  })),
  connect(mapStateToProps, mapDispatchToProps)
)(PrestitialAd)
